module.exports = __webpack_public_path__ + "static/media/InstagramIcon.c2d9873f.svg";